import React from 'react';

// Types
import { FormTypeType, GifQuestionType, ReviewFormTemplateType } from 'Shared/types/ReviewFormTemplate.type';

// Hooks
import { useQuestion } from './use-question';

// Components
import WpTextField from 'Wpds/components/text-field/WpTextField';
import QuestionWrapper from './QuestionWrapper';
import { WpGifPicker } from 'Wpds/components/gif';

type Props = {
  question: GifQuestionType;
  onChange: Function;
  handleDeleteQuestion: Function;
  handleDuplicateQuestion: Function;
  activeQuestionKey: string;
  setActiveQuestionKey: Function;
  handleMoveQuestion: Function;
  reviewFormType: FormTypeType;
  reviewFormTemplates: ReviewFormTemplateType[];
};

const GifQuestion = ({
  question,
  onChange,
  handleDeleteQuestion,
  activeQuestionKey,
  setActiveQuestionKey,
  handleDuplicateQuestion,
  handleMoveQuestion,
  reviewFormType,
  reviewFormTemplates,
}: Props) => {
  const { handleUpdateQuestion } = useQuestion({ question, onChange });

  const isActive = activeQuestionKey === question.key;

  // const baseClassName = 'GifQuestion';

  return (
    <QuestionWrapper
      question={question}
      reviewFormType={reviewFormType}
      reviewFormTemplates={reviewFormTemplates}
      onChange={handleUpdateQuestion}
      handleDeleteQuestion={handleDeleteQuestion}
      activeQuestionKey={activeQuestionKey}
      setActiveQuestionKey={setActiveQuestionKey}
      handleDuplicateQuestion={handleDuplicateQuestion}
      handleMoveQuestion={handleMoveQuestion}
    >
      {isActive ? (
        <WpTextField
          id="textarea-explainer"
          name="textarea-explainer"
          label="textarea-explainer"
          value="User will be provided with a selection of Gifs to choose as a response"
          multiline={2}
          labelHidden
          disabled
        />
      ) : (
        <WpGifPicker autoFocus={false} />
      )}
    </QuestionWrapper>
  );
};

export default GifQuestion;
